
import React, { useState } from "react";
import { Loading } from "../../Helper/Loading";
const Image_1 = "../assets/img/Loading.png";
const BrokenImage = '../assets/img/not_found.png'

export default function AfterWorkPhoto({ setshowWorkImagePopup, AfterWorkPhotoData, workPhotoData, workGridData, After, Before, Flag, LatLongFlag }) {

    // console.log(workGridData)
    const imageOnLoad = (event) => {
        if (event.currentTarget.className !== "error") {
            event.currentTarget.className = "success";
        }
    };
    const imageOnError = (event) => {
        event.currentTarget.src = BrokenImage;
        event.currentTarget.className = "error";
    };

    const [BeforeLoading, setBeforeLoading] = useState(true)
    const [BeforeError, setBeforeError] = useState(false)
    const [AfterLoading, setAfterLoading] = useState(true)
    const [AfterError, setAfterError] = useState(false)


    const BeforeimageOnLoad = () => {
        setBeforeLoading(false)
    }

    const BeforeimageOnError = () => {
        setBeforeLoading(false)
        setBeforeError(true)
    }

    const AfterimageOnLoad = () => {
        setAfterLoading(false)
    }

    const AfterimageOnError = () => {
        setAfterLoading(false)
        setAfterError(true)
    }

    return (
        <>
            <div className=" modal show fade" style={{ display: "block", backgroundColor: "#00000055", overflow: 'auto' }} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered mt-5" role="document">
                    <div className="modal-content" id='nested'>
                        <div className="modal-header popheding" id="popupheading">
                            <div className=" ml-4">
                                <span style={{ fontSize: '19px', fontWeight: 'bold' }}>
                                    {/* {Flag === "WorkNameHeading" && `Work Name - ${workGridData?.workname}`} */}
                                    {Flag === "WorkNameHeading" && `${workGridData?.workname}`}
                                </span>
                            </div>

                            <button type="button" className="btn-close mr-3 mt-1" data-dismiss="modal" aria-label="Close" data-backdrop='static'
                                style={{ color: 'white' }}
                                onClick={() => {
                                    setshowWorkImagePopup(false)
                                }}>
                                {/* <span className="x" aria-hidden="true">&times;</span> */}
                            </button>
                        </div>
                        <div className="row modal-body pt-0" style={{ height: "70vh", overflowX: "hidden" }} >
                            <div className="col-6 modal-header justify-content-center border-end " >
                                {/* <img src={ImageNotFound} /> */}
                                {/* {
                                    AfterWorkPhotoData.image === null ?
                                    // <img src={ImageNotFound} />
                                    <h1>hello</h1>
                                    :
                                    <h1>fj</h1>
                                } */}
                                {/* {
                                    AfterWorkPhotoData ?
                                        <img className="col-12" src={AfterWorkPhotoData == null ? "ImageNotFound" : AfterWorkPhotoData} style={{ width: "400px", height: "400px" }} />
                                        : <h4>No Image found</h4>
                                } */}

                                <div className=" fs-6 fw-bold text-black text-center" >
                                    <text className="text-center">{Before && Before ? Before : 'Before Work Photo'}</text>
                                    <span className="d-flex justify-content-center pt-3">
                                        {BeforeLoading && <Loading />}
                                        <>

                                            {
                                                !BeforeError ?
                                                    <>
                                                        <img className="col-12"
                                                            style={{ width: '70%' }}
                                                            src={workPhotoData}
                                                            onLoad={BeforeimageOnLoad}
                                                            onError={BeforeimageOnError}
                                                        />
                                                    </>
                                                    :
                                                    <img src="../assets/img/not_found.png" />

                                            }
                                        </>

                                        {/* {
                                            workPhotoData ?
                                                <img className="col-12" style={{ width: "400px", height: "400px" }} 
                                                src={workPhotoData == null ? "ImageNotFound" : workPhotoData}
                                                    onLoad={imageOnLoad} onError={imageOnError} />
                                                : 
                                                <img src="../assets/img/not_found.png" style={{ width:'10%'}}/>
                                        } */}


                                    </span>
                                    {
                                        Flag === "WorkNameHeading" &&
                                        <>
                                            <p className="mb-0 mt-3">Lattitude : {LatLongFlag == "LatLongFlag" && workGridData?.workLatitude}</p>
                                            <p>Longitude : {LatLongFlag == "LatLongFlag" && workGridData?.workLongitude}</p>
                                        </>
                                    }

                                </div>



                                {/* {

                                        AfterWorkPhotoData ?
                                            <img className="col-12"
                                                src={`data:image/png;base64,${AfterWorkPhotoData}`}
                                                style={{ width: "400px", height: "400px" }}
                                            />

                                            : 'No Image found'
                                } */}


                            </div>
                            <div className="col-6 modal-header justify-content-center"  >
                                <div className="fs-6 fw-bold text-black text-center" >
                                    {After && After ? After : 'After Work Photo'}
                                    <span className="d-flex justify-content-center pt-3">
                                        {BeforeLoading && <Loading />}
                                        <>
                                            {
                                                !AfterError ?
                                                    <>
                                                        <img className="col-12"
                                                            style={{ width: '70%' }}
                                                            src={AfterWorkPhotoData}
                                                            onLoad={AfterimageOnLoad}
                                                            onError={AfterimageOnError}
                                                        />

                                                    </>
                                                    :
                                                    <img src="../assets/img/not_found.png" />

                                            }
                                        </>
                                        {/* {
                                            AfterWorkPhotoData ?
                                                <img className="col-12" style={{ width: "400px", height: "400px" }} src={AfterWorkPhotoData == null ? "ImageNotFound" : AfterWorkPhotoData}
                                                    onLoad={imageOnLoad} onError={imageOnError} />
                                                : <img src="../assets/img/not_found.png" style={{ width: "200px", height: "200px" }} />
                                        } */}
                                    </span>
                                    {
                                        Flag === "WorkNameHeading" &&
                                        <>
                                            <p className="mb-0 mt-3">Lattitude : {workGridData?.afterLatitude}</p>
                                            <p>Longitude : {workGridData?.afterLongitude}</p>
                                        </>
                                    }

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


